"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("../styles");
const MultiSelect = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    label,
    placeholder,
    options = [],
    name,
    value,
    errors,
    id,
    className,
    style,
    size,
    onChange,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: className,
    ref: ref
  }, label && /*#__PURE__*/_react.default.createElement(_styles.StyledLabel, {
    htmlFor: name
  }, label), /*#__PURE__*/_react.default.createElement(_styles.MultiSelectStyle, (0, _extends2.default)({
    id: name,
    name: name,
    value: value || [],
    title: placeholder || '',
    style: style,
    containsErrors: errors && errors.length > 0,
    multiple: true,
    size: size,
    onChange: onChange
  }, props), options && (0, _map.default)(options).call(options, _ref2 => {
    let {
      label,
      value
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("option", {
      key: value,
      value: value
    }, label);
  })), /*#__PURE__*/_react.default.createElement(_styles.StyledErrorContainer, null, errors && (0, _map.default)(errors).call(errors, error => /*#__PURE__*/_react.default.createElement(_styles.ErrorMessage, {
    key: error
  }, error))));
});
MultiSelect.propTypes = {
  /**
   * A label string.
   */
  label: _propTypes.default.string,
  /**
   * A placeholder string will be used for the select's title attribute.
   */
  placeholder: _propTypes.default.string,
  /**
   * A list of objects containing the label and value corresponding to the select's options.
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  })),
  name: _propTypes.default.string,
  /**
   * The value prop must be an array for multiselect.
   */
  value: _propTypes.default.array,
  /**
   * A list of errors as strings for the input to render.
   */
  errors: _propTypes.default.arrayOf(_propTypes.default.string),
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  /**
   * onChange prop to control this component
   */
  onChange: _propTypes.default.func.isRequired,
  /**
   * Determines the height of multiselect (Eg. passing {options.length} as size prop)
   */
  size: _propTypes.default.number.isRequired
};
MultiSelect.displayName = 'MultiSelect';
var _default = exports.default = MultiSelect;
MultiSelect.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MultiSelect",
  "props": {
    "options": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "A list of objects containing the label and value corresponding to the select's options.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "label": {
              "name": "string",
              "required": true
            },
            "value": {
              "name": "union",
              "value": [{
                "name": "string"
              }, {
                "name": "number"
              }],
              "required": true
            }
          }
        }
      },
      "required": false
    },
    "label": {
      "description": "A label string.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placeholder": {
      "description": "A placeholder string will be used for the select's title attribute.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "name": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "value": {
      "description": "The value prop must be an array for multiselect.",
      "type": {
        "name": "array"
      },
      "required": false
    },
    "errors": {
      "description": "A list of errors as strings for the input to render.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "id": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "style": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "onChange": {
      "description": "onChange prop to control this component",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "size": {
      "description": "Determines the height of multiselect (Eg. passing {options.length} as size prop)",
      "type": {
        "name": "number"
      },
      "required": true
    }
  }
};